// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3W5sG","author":"Table_author__kH8XC","authorImage":"Table_authorImage__jN0Nx","unreadRow":"Table_unreadRow__dqzJC"};